<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [areaName]="areaName"
  [model]="model"
  [noSubmit]="true"
  [columns]="hColumns"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div style="margin: 50px auto; width: 70%">
      <label for="file">لطفا فایل مورد نظر را انتخاب کید:</label>
      <input type="button" id="loadFileXml" value="انتخاب فایل" onclick="document.getElementById('file').click();" />
      <input
        type="file"
        class="form-control"
        (input)="onFileChange($event)"
        multiple="false"
        placeholder="بارگذاری فایل اکسل"
        accept=".xlsx"
        id="file"
        style="display: none"
        value="Custom Button Name" />
    </div>
  </ng-container>
</dynamic-form>
